/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ListLodgingDoorsQueryResponse,
  ListLodgingDoorsQueryParams,
} from '../types/ListLodgingDoors'

function getListLodgingDoorsUrl() {
  const res = { method: 'GET', url: `/api/v1/places/lodging-doors/` as const }
  return res
}

/**
 * @summary List lodging doors
 * {@link /api/v1/places/lodging-doors/}
 */
export async function listLodgingDoors(
  params?: ListLodgingDoorsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListLodgingDoorsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getListLodgingDoorsUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
